import React from "react";
import { GraduationCap, Award, Star } from "lucide-react";

export const TIER_META = {
  trainee:   { label: "Trainee",   rate: 100, color: "#78584B", icon: GraduationCap },
  pro:       { label: "Pro",       rate: 120, color: "#6B0F1A", icon: Award },
  signature: { label: "Signature", rate: 150, color: "#B08D57", icon: Star },
};

export const TIER_ORDER = ["trainee", "pro", "signature"];

export function TierBadge({ tier, showRate = false, size = "sm" }) {
  if (!tier) {
    return (
      <span
        data-testid="tier-badge-unassigned"
        className="font-mono-tag inline-flex items-center gap-2 text-[10px] px-2.5 py-1 rounded-sm text-[#78584B] border border-[#1A0F0A]/12"
        style={{ backgroundColor: "rgba(26, 15, 10, 0.04)" }}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-[#78584B]/40" />
        Unassigned
      </span>
    );
  }
  const meta = TIER_META[tier];
  const Icon = meta.icon;
  const isLg = size === "lg";
  const isSignatureLg = tier === "signature" && isLg;

  return (
    <span
      data-testid={`tier-badge-${tier}`}
      className={[
        "tier-badge",
        `tier-badge--${tier}`,
        isLg && "tier-badge--lg",
        "font-mono-tag inline-flex items-center rounded-sm",
        isLg ? "text-[11px] gap-2.5 px-3.5 py-1.5" : "text-[10px] gap-2 px-2.5 py-1",
      ].filter(Boolean).join(" ")}
      style={{ "--tier-c": meta.color }}
    >
      <Icon
        className={isLg ? "w-3.5 h-3.5" : "w-3 h-3"}
        strokeWidth={isSignatureLg ? 2.5 : 2}
        {...(isSignatureLg ? { fill: "currentColor" } : {})}
      />
      <span className="tier-badge__label">{meta.label}</span>
      {showRate && (
        <span className="tier-badge__rate opacity-80">· ${meta.rate}/shoot</span>
      )}
    </span>
  );
}
